export default __webpack_public_path__ + "static/media/100k.66f790cb.png";